import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useLanguage } from "../../../i18n/useLanguage";
import { WheelPartItem } from "../../../queries/useSearchWheelsByVehicle";
import { KeyValue } from "../../../ui/KeyValue/KeyValue";
import { Placeholder } from "../../../ui/Placeholder";
import { Details } from "../Common/Details";

type WheelSpecProps = {
  part: WheelPartItem | null;
};

export const WheelSpec: FunctionComponent<WheelSpecProps> = ({ part }) => {
  const { t } = useTranslation();
  const [language] = useLanguage();
  const primaryPart = part?.partDetails.primaryPart;

  return (
    <Details className="text-xs grid gap-2 md:grid-cols-2">
      <div className="md:col-span-2">
        <Placeholder className="w-full" loading={!part}>
          {primaryPart?.wheelDescription[language] ||
            primaryPart?.wheelDescription.en ||
            "N/A"}
        </Placeholder>
        <hr className="mt-2" />
      </div>
      <KeyValue>
        <>{t("searchResults.partNumber")}:</>
        <Placeholder className="w-8" loading={!part}>
          {primaryPart?.wheelPartNumber}
        </Placeholder>
      </KeyValue>
      <KeyValue>
        <>{t("searchResults.diameter")}:</>
        <Placeholder className="w-8" loading={!part}>
          {primaryPart?.wheelDiameter}
        </Placeholder>
      </KeyValue>
      <KeyValue>
        <>{t("searchResults.width")}:</>
        <Placeholder className="w-8" loading={!part}>
          {primaryPart?.wheelWidth}
        </Placeholder>
      </KeyValue>
      <KeyValue>
        <>{t("searchResults.offset")}:</>
        <Placeholder className="w-8" loading={!part}>
          {primaryPart?.wheelOffset || "N/A"}
        </Placeholder>
      </KeyValue>
      <KeyValue>
        <>{t("searchResults.color")}:</>
        <Placeholder className="w-8" loading={!part}>
          {primaryPart?.wheelColour || "N/A"}
        </Placeholder>
      </KeyValue>
      <KeyValue>
        <>{t("searchResults.axiePartner")}:</>
        <Placeholder className="w-8" loading={!part}>
          {primaryPart?.wheelAxlePartner || "N/A"}
        </Placeholder>
      </KeyValue>
      <KeyValue>
        <>{t("searchResults.notes")}:</>
        <Placeholder className="w-8" loading={!part}>
          {primaryPart?.wheelComment || "N/A"}
        </Placeholder>
      </KeyValue>
    </Details>
  );
};
